/**
 * MASTER list of fabric order statuses
 * This is the SINGLE SOURCE OF TRUTH for all fabric order status options
 * 
 * Usage:
 * import { FABRIC_ORDER_STATUSES, getFabricStatusConfig } from '@/constants/fabricStatuses';
 */

export const FABRIC_ORDER_STATUSES = [
  { 
    value: 'pending', 
    label: 'Pending', 
    color: 'bg-red-900/80 text-white border-red-900',
    description: 'Fabric requirement identified, awaiting action'
  },
  { 
    value: 'not_ordered', 
    label: 'Not Ordered', 
    color: 'bg-red-900/80 text-white border-red-900',
    description: 'Fabric not yet ordered from supplier'
  },
  { 
    value: 'checking_with_supplier', 
    label: 'Checking with Supplier', 
    color: 'bg-orange-500/80 text-white border-orange-500',
    description: 'Verifying availability and details with supplier'
  },
  { 
    value: 'processing', 
    label: 'Processing', 
    color: 'bg-amber-600/80 text-white border-amber-600',
    description: 'Order being processed or prepared'
  },
  { 
    value: 'order_confirmed', 
    label: 'Order Confirmed', 
    color: 'bg-blue-600/80 text-white border-blue-600',
    description: 'Order confirmed by supplier'
  },
  { 
    value: 'in_transit', 
    label: 'In Transit', 
    color: 'bg-purple-600/80 text-white border-purple-600',
    description: 'Fabric shipped and in transit'
  },
  {
    value: 'in_stock',
    label: 'In Stock',
    color: 'bg-emerald-600/80 text-white border-emerald-600',
    description: 'Fabric available in stock'
  },
  { 
    value: 'received_sg', 
    label: 'Recd in SG', 
    color: 'bg-green-700/80 text-white border-green-700',
    description: 'Fabric received at Singapore location'
  },
  { 
    value: 'received_gobi', 
    label: 'Recd in Gobi', 
    color: 'bg-green-800/80 text-white border-green-800',
    description: 'Fabric received at Gobi location'
  },
  { 
    value: 'on_hold', 
    label: 'On Hold', 
    color: 'bg-slate-600/80 text-white border-slate-600',
    description: 'Order temporarily paused or on hold'
  },
  { 
    value: 'cancelled', 
    label: 'Cancelled', 
    color: 'bg-gray-700/80 text-white border-gray-700',
    description: 'Order cancelled'
  },
];

/**
 * Helper function to get status configuration by value
 * @param {string} status - Status value (e.g., 'pending', 'in_transit')
 * @returns {object} Status configuration object with label, color, description
 */
export const getFabricStatusConfig = (status) => {
  return FABRIC_ORDER_STATUSES.find(s => s.value === status) || 
    { label: status, color: 'bg-gray-500/20 text-gray-600', description: 'Unknown status' };
};

/**
 * Get all status values as an array
 * @returns {string[]} Array of status values
 */
export const getFabricStatusValues = () => {
  return FABRIC_ORDER_STATUSES.map(s => s.value);
};

/**
 * Check if a status value is valid
 * @param {string} status - Status value to validate
 * @returns {boolean} True if status is valid
 */
export const isValidFabricStatus = (status) => {
  return FABRIC_ORDER_STATUSES.some(s => s.value === status);
};
